import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { CodeListFeatureGate } from '../Guards/CodeListFeatureGate'
import { CodeList } from '../Components/Organisms/CodeList/CodeList'

/**
 * Routed Codes list page.
 */
@Route(RouteID.CODE)
export class CodeListPage extends Component {
    /**
     * Renders the Codes admin list page content tree.
     *
     * @returns Codes list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CODE}>
                <CodeListFeatureGate>
                    <LanguageContextProvider>
                        <CodeList />
                    </LanguageContextProvider>
                </CodeListFeatureGate>
            </RouteGuard>
        )
    }
}
